<template>
<div>
  <v-app-bar
  shrink-on-scroll
  prominent
  fade-img-on-scroll
  color="amber darken-3"
  :dense="$vuetify.breakpoint.mdAndUp"
  src="@/assets/ducksu_wide.jpeg"
  >
  <v-img src="@/assets/ducksu_wide.jpeg" style="display: none"/>
    <v-row dense align="center" class="mt-1">
      <v-col cols="12" md="3" lg="3">
        <h1 class="white--text">덕수네 어항</h1>
      </v-col>
      <v-col cols="12" md="9" lg="9" align="left" class="mb-2">
        <v-card outlined style="background-color: transparent;">
        <v-list dense style="background-color: transparent;">
            <v-list-item @click="goToKakaoPage">
              <v-list-item-icon>
                <img src="@/assets/kakao_icon.png/" style="height: 24px; width: auto;">
              </v-list-item-icon>
              <v-list-item-content>
              <v-list-item-subtitle class="white--text font-weight-black">
               <a class="white--text" style="fontSize: 20px;"  href="https://open.kakao.com/o/sTr3JbCe">오픈카카오로 연락주세요. (클릭)</a>
              </v-list-item-subtitle>
            </v-list-item-content>
            </v-list-item>
        </v-list>
      </v-card>
      </v-col>
    </v-row>
    <template v-slot:extension>
      <v-tabs  background-color="rgba(255, 255, 255, 0.4)" grow color="red">
        <v-tab class="font-weight-black" style="fontSize: 20px"  :class="{ 'black--text lighten-4': tab !== '분양' }" @click="tab='분양'">분양</v-tab>
        <v-tab class="font-weight-black" style="fontSize: 20px" :class="{ 'black--text': tab !== '이야기' }" @click="tab='이야기'">분양후기</v-tab>
	<v-tab class="font-weight-black" style="fontSize: 20px" :class="{ 'black--text': tab !== '물생활정보' }" @click="tab='물생활정보'">정보</v-tab>
	<v-tab class="font-weight-black" style="fontSize: 20px" :class="{ 'black--text': tab !== '게시판'}" @click="tab='게시판'">게시판</v-tab>
 </v-tabs>
    </template>
  </v-app-bar>
  <v-container style="height:300px"> 
    <v-card class="pa-4" v-if="tab=='분양'" style="min-height:2000px">
      <v-row>
        <v-col
          v-for="product in products"
          :key="product.id"
          class="d-flex child-flex"
          cols="12" md="4" lg="4"
          @click="setProduct(product)"
        >
          <v-card outlined class="mx-auto">
            <v-img
              :src="product.image"
              height="300px"
            ></v-img>
            <v-card-title>
              {{product.title}}
            </v-card-title>
           
              <template v-if="product.is_available==true">
                <v-card-subtitle class="green--text">
                  분양중입니다.
                </v-card-subtitle>
              </template>
              <template v-else>
                <v-card-subtitle class="red--text">
                  분양완료입니다.
                </v-card-subtitle>
              </template>
          </v-card>
        </v-col>
     </v-row>
    </v-card>

    <v-card class="pa-4" v-if="tab=='이야기'" style="min-height:2000px">
      <v-row>
        <v-col
          v-for="story in storys"
          :key="story.id"
          class="d-flex child-flex"
          cols="12" md="4" lg="4"
          @click="setStory(story)"
        >
          <v-card outlined class="mx-auto">
            <v-img
              :src="story.image"
              height="300px"
            ></v-img>
            <v-card-title>
              {{story.title}}
            </v-card-title>
            <v-card-subtitle>
              {{formatDate(story.created_at )}} 
            </v-card-subtitle>
          </v-card>
        </v-col>
        <v-col
          class="mb-5"
          cols="12"
        >
        </v-col>
     </v-row>
    </v-card>

    <v-card class="pa-4" v-if="tab=='물생활정보'" style="min-height:2000px">
      <v-row>
        <v-col
          v-for="post in posts"
          :key="post.id"
           @click="setPost(post)"
	   cols="12"
        >
          <v-card outlined class="mx-auto">
            <v-card-title>
              {{post.title}}
            </v-card-title>
            <v-card-subtitle>
              {{formatDate(post.created_at )}}
            </v-card-subtitle>
          </v-card>
        </v-col>
     </v-row>
    </v-card>
    <v-dialog v-model="card_detail_view" ref="cardDetailView"  max-width="600px" top>
      <v-card class="mx-auto">
        <v-img
              :src="selected_product.image"
              height="my-auto"
            ></v-img>
        <v-card-title>
       {{selected_product.title}} <v-chip class="grey--text text-capitalize ml-1"
                text
                outlined
                @click="copyProductUrl(selected_product)"
                >URL 복사</v-chip>
 		
        </v-card-title>
        <template v-if="selected_product.is_available==true">
          <v-card-title class="green--text">
            판매중입니다.
                <v-chip class="red--text text-capitalize ml-1"
                text
                outlined
                @click="card_detail_view=!card_detail_view"
                >닫기</v-chip>
          </v-card-title>
        </template>
        <template v-else>
          <v-card-title class="red--text">
            분양완료입니다.                 
		<v-chip class="red--text text-capitalize ml-1"
                text
                outlined
                @click="card_detail_view=!card_detail_view"
                >닫기</v-chip>
          </v-card-title>
        </template>
        <v-card-text v-html="selected_product.content">
        </v-card-text>
        <v-card-actions>
          <v-btn outlined block class="red--text text-capitaliz"  @click="card_detail_view = false">닫기</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="story_detail_view" ref="storyDetailView" max-width="600px">
      <v-card class="mx-auto">
        <v-img
              :src="selected_story.image"
              height="my-auto"
            ></v-img>
        <v-card-title>
       {{selected_story.title}}
        </v-card-title>
        <v-card-text v-html="selected_story.content">
        </v-card-text>
        <v-card-actions>
          <v-btn outlined block class="red--text text-capitaliz" @click="story_detail_view = false">닫기</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="post_detail_view" ref="postDetailView" max-width="600px">
      <v-card class="mx-auto">
           <!-- Image slider for post images -->
	   <v-carousel v-if="selected_post!={}"  hide-delimiters height="300">
              <v-carousel-item v-for="(image, index) in selected_post.images" :key="index">
                <v-img :src="image.image" :alt="image.caption" class="white--text" height="100%">
                  <v-row class="fill-height" align="end" justify="end">
                    <v-col class="text-right mr-4">
                      <h2>{{ image.caption }}</h2>
                    </v-col>
                  </v-row>
                </v-img>
              </v-carousel-item>
            </v-carousel>
             <v-card-title>
       {{selected_post.title}}<v-chip class="grey--text text-capitalize ml-1"
                text
                outlined
                @click="copyPostUrl(selected_post)"
                >URL 복사</v-chip>
		<v-chip class="red--text text-capitalize ml-1"
                text
                outlined
                @click="post_detail_view=!post_detail_view"
                >닫기</v-chip>
        </v-card-title>
        <v-card-text v-html="selected_post.content">
        </v-card-text>
        <v-card-actions>
          <v-btn outlined block class="red--text text-capitaliz" @click="post_detail_view = false">닫기</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

        <!--URL Copy-->
        <v-dialog v-model="copied" max-width="300px">
		<v-card><v-card-title>URL를 복사하였습니다.
		<v-btn outlined block @click="copied=!copied">닫기</v-btn>
			</v-card-title></v-card>
	</v-dialog>

        <!--PopUp -->
        <v-dialog v-for="(popup, index) in PopupData"  v-model="popup.is_active"  max-width="600px">
		<v-card>
       			 <v-card-title class="headline">
         			 {{ popup.title }}
       			 </v-card-title>
				<v-divider />

       			 <v-card-text>
				<div class="ma-3">
                                 <h3>{{ popup.content }}</h3>
                                </div>
         			 <!-- 이미지가 필요한 경우 -->
         			 <v-img
           				 
           				 :src="'http://api.ducksu.net'+popup.image"
           				
         			 ></v-img>
       			 </v-card-text>

       			 <v-card-actions>
         		 <!-- 광고 링크 -->
         			 <v-btn
           				 v-if="popup.link"
           				 :href="popup.link"
           				 target="_blank"
           				 color="primary"
         				 >
           				 더 알아보기
         			 </v-btn>
         			 <v-spacer></v-spacer>
         			 <!-- 닫기 버튼 -->
         			 <v-btn color="secondary" text @click="popup.is_active = false">
           			 닫기
         			</v-btn>
       			 </v-card-actions>
      </v-card>
        </v-dialog>
  </v-container>
  </div>
</template>

<script>
import axios from 'axios'
  export default {
    data: () => ({
      card_detail_view: false,
      story_detail_view: false,
     post_detail_view: false,
      tab: '분양',
      products: [],
      selected_product: {},
      selected_product_id: null,

      currentPage: 1,
      storys: [],
      selected_story: {},

      posts: [],
      selected_post: {}, 
      selected_post_id : null,
      nextPage:1,
      isLoading: false,

      offsetTop: 0,

      login_view: false,
      sign_in : false, 
      chat_list : false, 
      chat_room : false,

      copied : false,
      
      PopupData: [],
    }),
    component:{
    },
    watch: {
      tab(newTab, oldTab) {
        if (newTab === '분양') {
          // '분양' 또는 '이야기'로 탭이 변경될 때 실행할 기능을 여기에 추가합니다.
          this.currentPage=1
          this.getProduct();
        } else if ( newTab === '이야기') {
          this.currentPage=1
          this.getStory();
        } else if ( newTab === '물생활정보') {
          this.currentPage=1
          this.getPost();
        }
      },
      selected_product_id(newProduct, oldProdcut){
          this.getSelectedProduct()
      },
      selected_post_id(newPost, oldPost){
         this.getSelectedPost() 
      } 
    },
    created() {
      // 초기 데이터 로드 시점에 스크롤 위치를 조정하여 스크롤 이벤트를 발생시킵니다.
      window.scrollTo(0, document.body.scrollHeight);
    },
    mounted(){
      this.getPopupAD()
      this.getClinentInfor()
      window.addEventListener('scroll', this.handleScroll)
      const params = new URLSearchParams(window.location.search);
      this.selected_product_id = params.get('selected_product');
      this.selected_post_id = params.get('selected_post');
      this.getProduct()
   },
    beforeDestroy() {
       window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
      getPopupAD(){
        axios
        .get('api/product/popup-ads/')
        .then(res=>{
           this.PopupData = res.data
           console.log('popup data', res.data)
        })
        .catch(err=>{
           console.log('popup err',err)
        })
      },
      handleScroll() {
          let scrollY = window.scrollY; // scrollY: 현재 스크롤된 페이지의 세로(Y) 위치를 나타내는 변수입니다. window.scrollY를 통해 현재 페이지의 세로 스크롤 위치를 얻습니다.
          let innerHeight = window.innerHeight; // innerHeight: 현재 브라우저 창의 내부 높이를 나타내는 변수입니다. window.innerHeight를 통해 현재 브라우저 창의 높이를 얻습니다. 이 값은 브라우저 창의 높이를 나타내며, 브라우저 창의 크기가 변경되면 해당 값도 업데이트됩니다.
          let offsetHeight = document.body.offsetHeight; // offsetHeight: 현재 페이지의 전체 높이를 나타내는 변수입니다. document.body.offsetHeight를 통해 현재 페이지의 전체 높이를 얻습니다. 이 값은 페이지의 내용이나 요소에 따라 동적으로 변할 수 있습니다.
          if (scrollY + innerHeight >= offsetHeight) {
                this.currentPage += 1;
                if(this.tab=='분양') {
                    axios.get(`api/product/product-list/?page=${this.currentPage}`, {
                        params: {
                            offset: (this.currentPage - 1) * 10
                        }
                    })
                    .then(response => {
                        this.products.push(...response.data.results); // ...response.data.results에서 ...을 사용하는 경우, 서버 응답에서 추출한 results 배열의 요소들을 현재 배열에 전개하여 추가하는 역할을 합니다. 즉, 배열을 확장시키는 역할을 합니다.
                    })
                    .catch(error => {
                        console.log(error);
                    })

                } else if (this.tab=='이야기') {
                    axios.get(`api/product/story-list/?page=${this.currentPage}`, {
                        params: {
                            offset: (this.currentPage - 1) * 10
                        }
                    })
                    .then(response => {
                        this.storys.push(...response.data.results); // ...response.data.results에서 ...을 사용하는 경우, 서버 응답에서 추출한 results 배열의 요소들을 현재 배열에 전개하여 추가하는 역할을 합니다. 즉, 배열을 확장시키는 역할을 합니다.
                    })
                    .catch(error => {
                        console.log(error);
                    })

                } else if (this.tab=='물생활정보'){
                    axios.get(`api/product/post/?page=${this.currentPage}`, {
                        params: {
                            offset: (this.currentPage - 1) * 10
                        }
                    })
                    .then(response => {
                        this.storys.push(...response.data.results); // ...response.data.results에서 ...을 사용하는 경우, 서버 응답에서 추출한 results 배열의 요소들을 현재 배열에 전개하여 >추가하는 역할을 합니다. 즉, 배열을 확장시키는 역할을 합니다.
                    })
                    .catch(error => {
                        console.log(error);
                    })

                }
            }
      },

    //URL Compy, 
    copyProductUrl(selected_product) {
      	navigator.clipboard.writeText(`https://ducksu.net/?selected_product=${selected_product.id}`)
        .then(() => {
        	this.copied = true; // 복사 성공 시 알림 표시
        })
        .catch((error) => {
          console.error('Failed to copy URL:', error);
        });
    },

    copyPostUrl(selected_post) {
	navigator.clipboard.writeText(`https://ducksu.net/?selected_post=${selected_post.id}`)
        .then(() => {
          this.copied = true; // 복사 성공 시 알림 표시
        })
        .catch((error) => {
         console.error('Failed to copy URL:', error);
        });
    },
    getSelectedProduct(){
       axios.get(`api/product/product-detail/${this.selected_product_id}/`)
        .then(res=>{
           this.setProduct(res.data)
           console.log(res.data.image)
        })
        .catch(error => {
          console.error('요기', error);
        });
    }, 
    getSelectedPost(){
        axios.get(`api/product/post-detail/${this.selected_post_id}/`)
        .then(res=>{
          this.setPost(res.data)
        })
        .catch(error => {
          console.error('Error fetching data:', error);
        });
    }, 

      getProduct(){
        axios.get(`api/product/product-list/?page=${this.currentPage}`)
        .then(res=>{
          this.products = res.data.results;
        })
        .catch(error => {
          console.error('Error fetching data:', error);
        });
      },

      getStory(){
        axios.get(`api/product/story-list/?page=${this.currentPage}`)
        .then(res=>{
          this.storys = res.data.results;
        })
        .catch(error => {
          console.error('Error fetching data:', error);
        });
      },

      getPost(){
        axios.get(`api/product/posts/?page=${this.currentPage}`)
        .then(res=>{
          this.posts = res.data.results;
        })
        .catch(error => {
          console.error('Error fetching data:', error);
        });
      },

      goToKakaoPage() {
        window.open("https://open.kakao.com/o/sTr3JbCe", "_blank");
      },

      setProduct(product){
        this.tab='분양'
        this.selected_product = product
        this.selectedProductTextfield()
        this.card_detail_view = true
	this.$nextTick(() => {
      		const cardDetailView = this.$refs.cardDetailView;
      		if (cardDetailView) {
        		cardDetailView.scrollTop = cardDetailView.scrollHeight - cardDetailView.clientHeight;
     		 }
    		});
      	},

      setStory(story){
        this.selected_story = story
        this.selectedStoryTextfield()
        this.story_detail_view = true
      },

      setPost(post){
         this.tab='물생활정보'
	 this.selected_post = post
         this.post_detail_view = true
	},

	
	getClinentInfor(){
          // const self = this; // Vue 컴포넌트 내부에서의 this를 캡처합니다.
          // HTML의 <script> 요소를 생성한다
          const scriptElement = document.createElement('script');
          // <script> 요소의 src 속성을 설정한다
          scriptElement.src = 'https://ipinfo.io?callback=callback';
          // <body> 요소의 하위 끝에 붙인다
          document.body.appendChild(scriptElement);
          window.callback = function(data){
              const callbackData = {
                  connect_ip : data.ip,
                  connect_city : data.city,
                  connect_region : data.region,
                  connect_country : data.country,
                  connect_ioc : data.loc,
                  connect_org : data.org,
                  connect_timezone : data.timezone
              };
              axios.post('/api/product/connect_infors/', callbackData)
          };
      },
      openChatApp(){
		this.login_view= true
	},

      onScroll (e) {
        this.offsetTop = e.target.scrollTop
      },

      formatDate(dateTimeString) {
          if(dateTimeString==null){
          } else {
              const dateTime = new Date(dateTimeString);
              // const options = { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric'};
              const options = { year: 'numeric', month: 'numeric', day: 'numeric'};
              return dateTime.toLocaleString(undefined, options);
          }
	      },
      selectedProductTextfield() {
        this.selected_product.content = this.selected_product.content.toString().replace(/(\n|\r\n)/g, '<br/>')
	    },
      selectedStoryTextfield() {
        this.selected_story.content = this.selected_story.content.toString().replace(/(\n|\r\n)/g, '<br/>')
      },
    },
  computed:{
    formattedDateTimes() {
			return this.dateTimeStrings.map((dateTimeString) => this.formatDate(dateTimeString));
	    },
    }
  }
</script>
<style>
.image-with-border {
  border: 1px solid orange; /* 태두리 스타일 및 두께를 지정하세요 */
  border-radius: 8px; /* 원하는 경우 태두리의 모서리를 둥글게 만들 수 있습니다 */
  max-width: 100%; /* 이미지가 부모 요소의 최대 너비를 가짐 */
  width: 60px; 
  height: 60px; 
}
.my-content {
  overflow-y: auto; /* 세로 스크롤을 항상 표시 */
  max-height: 100vh; /* 콘텐츠 최대 높이 */
}
</style>
